var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaCompletedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.9446,
    cy: 31.9446,
    r: 31.9446,
    fill: "#ECF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.293 44.3957H25.7096C21.3346 44.3957 18.418 42.2082 18.418 37.104V26.8957C18.418 21.7915 21.3346 19.604 25.7096 19.604H40.293C44.668 19.604 47.5846 21.7915 47.5846 26.8957V37.104C47.5846 42.2082 44.668 44.3957 40.293 44.3957Z",
    stroke: "#1E247E",
    strokeWidth: 2.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 36.375C35.4162 36.375 37.375 34.4162 37.375 32C37.375 29.5838 35.4162 27.625 33 27.625C30.5838 27.625 28.625 29.5838 28.625 32C28.625 34.4162 30.5838 36.375 33 36.375Z",
    fill: "#DA867D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.418 27.6252H19.8763C24.2513 27.6252 25.7096 26.1668 25.7096 21.7918V20.3335",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5846 27.6252H46.1263C41.7513 27.6252 40.293 26.1668 40.293 21.7918V20.3335",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.418 36.375H19.8763C24.2513 36.375 25.7096 37.8333 25.7096 42.2083V43.6667",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5846 36.375H46.1263C41.7513 36.375 40.293 37.8333 40.293 42.2083V43.6667",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34C34.1046 34 35 33.1046 35 32C35 30.8954 34.1046 30 33 30C31.8954 30 31 30.8954 31 32C31 33.1046 31.8954 34 33 34Z",
    fill: "#F0C330"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_31799_51093",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0555 0.0556414C49.698 0.0862892 63.9752 14.4132 63.9445 32.0556C63.9139 49.6981 49.587 63.9753 31.9445 63.9447C14.302 63.914 0.024845 49.5871 0.0554928 31.9447C0.0861406 14.3022 14.413 0.0249936 32.0555 0.0556414ZM31.9483 61.7321C48.3689 61.7606 61.7034 48.4723 61.732 32.0518C61.7605 15.6313 48.4722 2.29672 32.0516 2.26819C15.6311 2.23967 2.29657 15.528 2.26804 31.9485C2.23952 48.369 15.5278 61.7036 31.9483 61.7321Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0555 0.0556414C49.698 0.0862892 63.9752 14.4132 63.9445 32.0556C63.9139 49.6981 49.587 63.9753 31.9445 63.9447C14.302 63.914 0.024845 49.5871 0.0554928 31.9447C0.0861406 14.3022 14.413 0.0249936 32.0555 0.0556414ZM31.9483 61.7321C48.3689 61.7606 61.7034 48.4723 61.732 32.0518C61.7605 15.6313 48.4722 2.29672 32.0516 2.26819C15.6311 2.23967 2.29657 15.528 2.26804 31.9485C2.23952 48.369 15.5278 61.7036 31.9483 61.7321Z",
    stroke: "#3876BB",
    strokeWidth: 4.79168,
    mask: "url(#path-9-inside-1_31799_51093)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaCompletedIcon);
export default __webpack_public_path__ + "static/media/CACompletedIcon.ecdf1351fa51dbc32dd56c61dd2863c8.svg";
export { ForwardRef as ReactComponent };